export const TooltipOption = {
  TRANSFORMY: 'transformY',
  COLORTHEME: 'colorTheme',
};
